import { gql } from "apollo-angular";

const ADD_CROSS_REFERENCE_NOTE= gql`
mutation AddCrossReferenceNote(
  $crossReferenceId: Long!
  $fromProductId: Long!
  $toProductId: Long!
  $note: String!
) {
  addCrossReferenceNote(
    addCrossReferenceNote: {
      crossReferenceId: $crossReferenceId
      fromProductId: $fromProductId
      toProductId: $toProductId
      note: $note
    }
  ) {
    note
  }
}
`;

export default ADD_CROSS_REFERENCE_NOTE;